import _ from '@/utils/lodash-optimized'
import Nucc from 'shared_src/dictionaries/providers/Nucc'

import { phoneMapping, faxMapping } from './lib/phone.js'
import { transform } from './mapper.js'

const notesEx = {
  url: 'http://narushealth.com/fhir/provider-network-practitioner-notes'
}

const emailMapping = [
  {
    fhir: [ 'value' ],
    form: [ 'address' ]
  },
  {
    fhir: [ 'rank' ],
    form: [ 'preferred' ],
    to_fhir: f => (f ? 1 : 2),
    to_form: f => f === 1
  }
]

const authorizationEx = {
  url: 'http://narushealth.com/fhir/medical-team-provider-authorization'
}

const filterNils = arr => arr.filter(item => !_.isNil(item))

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Practitioner'
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'identifier' ],
    form: [ 'npi' ],
    to_fhir: v =>
      (v
        ? [
          {
            system: 'http://npiregistry.cms.hhs.gov/npi-id',
            value: v
          }
        ]
        : null),
      to_form: idnt => idnt?.[0]?.value
  },
  {
    fhir: [ 'active' ],
    fhir_const: true
  },
  {
    fhir: [ 'name', 0, 'family', 0 ],
    form: [ 'lastName' ]
  },
  {
    fhir: [ 'name', 0, 'given', 0 ],
    form: [ 'firstName' ]
  },
  {
    fhir: [ 'name', 0, 'given', 1 ],
    form: [ 'middleName' ]
  },
  {
    fhir: [ 'name', 0, 'prefix', 0 ],
    form: [ 'prefix' ]
  },
  {
    fhir: [ 'qualification', 0, 'code', 'text' ],
    form: [ 'credentials' ]
  },
  {
    fhir: [ 'name', 0, 'suffix', 0 ],
    form: [ 'suffix' ]
  },
  phoneMapping(),
  faxMapping(),
  {
    $mapping: emailMapping,
    fhir: [
      'telecom',
      {
        $filter: { system: 'email' },
        $collection: true
      }
    ],
    form: [ 'emails', { $collection: true }],
    to_fhir: v => filterNils(v)
  },
  {
    fhir: [ 'address', { use: 'work' }, 'line', 0 ],
    form: [ 'address1' ]
  },
  {
    fhir: [ 'address', { use: 'work' }, 'line', 1 ],
    form: [ 'address2' ]
  },
  {
    fhir: [ 'address', { use: 'work' }, 'city' ],
    form: [ 'city' ]
  },
  {
    fhir: [ 'address', { use: 'work' }, 'postalCode' ],
    form: [ 'zip' ]
  },
  {
    fhir: [ 'address', { use: 'work' }, 'state' ],
    form: [ 'state' ]
  },
  {
    fhir: [ 'role', 0, 'code', 'coding', 0 ],
    form: [ 'specialty' ],
    to_fhir: specialty => ({
      system: 'http://nucc.org/provider-taxonomy',
      code: specialty,
      display: _.filter(Nucc, n => n.code === specialty)[0].label
    }),
    to_form: coding => coding.code
  },
  {
    fhir: [ 'role', 0, 'code', 'text' ],
    form: [ 'roleText' ]
  },
  {
    fhir: [ 'role', 0, 'organization', 'display' ],
    form: [ 'practiceName' ]
  },
  {
    fhir: [ '_pcp' ],
    to_fhir: pcp =>
      (pcp
        ? {
          text: 'PCP',
          coding: [{
            code: '446050000',
            system: 'http://snomed.info/sct'
          }]
        }
        : null),
    form: [ 'pcp' ],
    to_form: pcp => !!(pcp && pcp.text === 'PCP')
  },
  {
    fhir: [ 'extension', notesEx, 'valueString' ],
    form: [ 'notes' ]
  },
  {
    fhir: [ 'extension', authorizationEx, 'valueBoolean' ],
    form: [ 'authorization' ]
  }
]

export const mapTeamMember = (patientId, form) =>
  transform(form, mapping, [ 'form', 'fhir' ])

export const unmapTeamMember = data =>
  transform(data, mapping, [ 'fhir', 'form' ])
